import { render, staticRenderFns } from "./EquipmentAdditionalInfo.vue?vue&type=template&id=59467e48"
import script from "./EquipmentAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./EquipmentAdditionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports